import React from "react";
// import { useLocation } from "react-router-dom";
import HeaderSignup from "./HeaderSignup";
import FooterSignup from "./FooterSignup";
import "./PageWrapper.css";

interface PageWrapperProps {
  children: React.ReactNode;
  onBack?: () => void;
}

// const SESSION_KEY = "start_timer";

const PageWrapper: React.FC<PageWrapperProps> = ({ children, onBack }) => {
  // const location = useLocation();
  // const match = location.pathname.match(/^\/getting-started\/step-(\d+|13b)$/);
  // const stepNumber = match ? String(match[1]) : null;

  // const isCheckoutPayment = location.pathname === "/glp1/checkout/payment";


  // const showBanner = useMemo(() => {
  //   if (location.pathname === "/glp1/checkout") return true;
  //   if (location.pathname === "/glp1/checkout/payment") return true;
  //   if (location.pathname.startsWith("/glp1/getting-started")) return false;
  
  //   // Preserve existing logic for /getting-started/step-14 and 13b
  //   return (
  //     location.pathname === "/" ||
  //     (stepNumber && (stepNumber === "13b" || parseInt(stepNumber, 10) <= 14))
  //   );
  // }, [location.pathname, stepNumber]);
  

  // const [remainingTime, setRemainingTime] = useState<number>(0);

  // useEffect(() => {
  //   if (stepNumber === "14" || isCheckoutPayment) {
  //     const TIMER_DURATION = 9 * 60 * 1000 + 59 * 1000; // 9:59
  //     const now = Date.now();
  //     let startTime = sessionStorage.getItem(SESSION_KEY);

  //     // Start timer only when entering Step-14 and timer not started
  //     if (!startTime) {
  //       sessionStorage.setItem(SESSION_KEY, now.toString());
  //       startTime = now.toString();
  //     }

  //     const calculateRemaining = () => {
  //       const elapsed = Date.now() - parseInt(startTime!, 10);
  //       const remaining = TIMER_DURATION - elapsed;
  //       return Math.max(0, Math.floor(remaining / 1000));
  //     };

  //     setRemainingTime(calculateRemaining());

  //     const interval = setInterval(() => {
  //       setRemainingTime(calculateRemaining());
  //     }, 1000);

  //     return () => clearInterval(interval);
  //   } else {
  //     setRemainingTime(0); // clear timer outside step-14
  //   }
  // }, [location.pathname, stepNumber]);

  // const renderTimer = () => {
  //   const minutes = String(Math.floor(remainingTime / 60)).padStart(2, "0");
  //   const seconds = String(remainingTime % 60).padStart(2, "0");
  //   const isBlinking = remainingTime <= 60 && remainingTime > 0;

  //   return (
  //     <span className="timer-wrapper">
  //       Offer expires in
  //       <span className={`timer-box ${isBlinking ? "blinking" : ""}`}>
  //         <span className="timer-value">{minutes}</span>
  //         <span className="timer-label">mins</span>
  //       </span>
  //       {":"}
  //       <span className={`timer-box ${isBlinking ? "blinking" : ""}`}>
  //         <span className="timer-value">{seconds}</span>
  //         <span className="timer-label">secs</span>
  //       </span>
  //     </span>
  //   );
  // };

  return (
    <div className="page-wrapper">
      {/* {showBanner && (
        stepNumber === "14" || isCheckoutPayment ? (
          <div className="promo-banner-height">
            <span className="discount-amount">$100 off</span> your first month today!
            {renderTimer()}
          </div>
        ) : (
          <div className="promo-banner">
            <span className="discount-amount">$100 off</span> your first month today!{" "}
            use code <span className="discount-code">100CLAYA</span> at checkout
          </div>
        )
      )} */}
      <HeaderSignup onBack={onBack}/>
      <main className="page-content">{children}</main>
      <FooterSignup />
    </div>
  );
};

export default PageWrapper;